import { useEffect, useMemo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { toastService } from "@miplatform/toast";
import { mdiLockOutline } from "@mdi/js";
import { Box, Typography } from "@mui/material";
import { useCalendarLockContext } from "../../../providers";

export function CalendarLockBanner() {
  const { classes } = useStyles();
  const { isLockedByOtherUser, lockDetails } = useCalendarLockContext();

  const lockMessage = useMemo(() => lockDetails?.message, [lockDetails]);

  useEffect(() => {
    if (isLockedByOtherUser && lockMessage) {
      toastService.error({ text: lockMessage ?? "" });
    }
  }, [isLockedByOtherUser, lockMessage]);

  if (!isLockedByOtherUser) {
    return null;
  }

  return (
    <Box className={classes.lockTextContainer}>
      <MiIcon path={mdiLockOutline} size={0.75} />
      <Typography variant={TYPOGRAPHY_VARIANTS.BODY2}>
        {lockDetails?.message}
      </Typography>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  lockTextContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: theme.palette.warning.light,
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    width: "100%",
    borderRadius: theme.spacing(1),
  },
}));
